module.exports = __webpack_public_path__ + "img/ch09_20_文件夹若依.99a2c6a5.jpg";